@import 'styles/mixins';
@import 'styles/variables';

.prompt {
  @include md-regular;

  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 4px 4px 4px 12px;
  border-radius: 6px;
  background: var(--neutral-0);
  box-shadow: inset 0 0 0 1px var(--neutral-10);
  color: var(--selected-stroke);
  caret-color: var(--selected-stroke);

  [data-autopilot-system-redesign='on'] & {
    caret-color: var(--dark-80);
    box-shadow: none;
    border: 1px solid var(--dark-8);
    color: var(--dark-80);

    &:hover {
      border: 1px solid var(--dark-15);
    }
  }

  &.largeInput {
    padding: 6px 6px 6px 12px;
  }

  &.focused {
    box-shadow: 0 0 0 2px var(--selected-fill);

    [data-autopilot-system-redesign='on'] & {
      border: 1px solid var(--dark-80);
    }
  }

  .textarea {
    @include md-regular;
    @include hide-scrollbar;
    flex: 1;
    height: 28px;
    width: 100%;
    padding: 4px 0;
    resize: none;
    background: transparent;
    color: var(--dark-80);

    &::placeholder {
      color: var(--dark-60);
    }
  }

  .submitButton {
    align-self: flex-end;
  }
}
